import { trackEcommerce, eventNameConstants } from 'dibs-tracking';

const DEFAULT_FEATURED_TARCKING_OBJ = {
    id: 'L2-result-tiles',
    name: 'L1|Result Tiles',
};

export function trackPromoImpressions(promotions: string[], position?: number): void {
    trackEcommerce({
        type: 'promotionImpression',
        eventName: eventNameConstants.EVENT_VIEW_PROMOTION,
        promotions: promotions.map((promotion, index) => ({
            position: position || index + 1,
            creative: promotion,
            ...DEFAULT_FEATURED_TARCKING_OBJ,
        })),
    });
}

export const trackPromoClick = (promotion: string, position: number = 1): void => {
    trackEcommerce({
        type: 'promoClick',
        eventName: eventNameConstants.EVENT_SELECT_PROMOTION,
        promotions: [
            {
                position,
                creative: promotion,
                ...DEFAULT_FEATURED_TARCKING_OBJ,
            },
        ],
    });
};
